PegasusTemplate.ViewOptionsController = Em.Controller.extend({
  needs: ['template'],
  isStandaloneBinding: Em.Binding.oneWay('controllers.template.isStandalone'),
  canSendTest: function(){
    return PegasusTemplate.EmailTemplate.detectInstance( this.get('controllers.template.content') );
  }.property('controllers.template.content'),
  zoomValue: 100,
  incrementZoomValue: function(){
    if ( this.get('zoomValue') === 100 ) { return; }
    this.set('zoomValue', this.get('zoomValue') + 10 );
  },
  decrementZoomValue: function(){
    if ( this.get('zoomValue') === 10 ) { return; }
    this.set('zoomValue', this.get('zoomValue') - 10 );
  }
});
